import { useQuery } from '@tanstack/vue-query'
import { apiClient } from '@/apis/instances/api-client'
import { checkApiResponse } from '@/apis/instances/check-api-response'
import { ApiV2ReservationsettingElFindOneParams } from '@/apis/swaggers/v2/v2-swagger'
import { QUERY_KEY } from '@/apis/swaggers/swagger-docs'
import { QueryComposableParams } from '@/types/query-options'
import { resolveMaybeGetter } from '@/util/resolve-maybe-getter'

type QueryParams = QueryComposableParams<ApiV2ReservationsettingElFindOneParams, unknown>

const fetchReservationSettingFindOne = async (params: ApiV2ReservationsettingElFindOneParams) => {
  const { data } = await apiClient.v2.apiV2ReservationsettingElFindOne(params);
  return checkApiResponse(data);
}

export const v2ReservationSettingKeys = {
  all: [QUERY_KEY.v2apiV2ReservationsettingElFindOne] as const,
  detail: (params: ApiV2ReservationsettingElFindOneParams) => [...v2ReservationSettingKeys.all, params] as const,
}

/**
 * 명령형(await) 호출용 쿼리 정의 — `queryClient.fetchQuery(v2ReservationSettingFindOneQueryOptions(params))`
 * 예약 설정은 mutation·FCM(d_v2ReservationSettingUpdate_el) invalidation 이 완전 커버 — staleTime Infinity.
 */
export const v2ReservationSettingFindOneQueryOptions = (params: ApiV2ReservationsettingElFindOneParams) => ({
  queryKey: v2ReservationSettingKeys.detail(params),
  queryFn: () => fetchReservationSettingFindOne(params),
  staleTime: Infinity,
  gcTime: Infinity,
})

export const useV2ReservationSettingFindOneQuery = ({ params, options }: QueryParams) => {
  return useQuery(() => ({
    queryKey: v2ReservationSettingKeys.detail(resolveMaybeGetter(params)),
    queryFn: () => fetchReservationSettingFindOne(resolveMaybeGetter(params)),
    ...resolveMaybeGetter(options ?? {}),
  }))
}
